import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PlgApi } from '../plg-api';
import type {
    IGetInvitationListRequest,
    IInvitationListResponse,
    IRedeemRequest,
    IRewardStatusResponse,
} from '../../types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';

@injectable()
export class PlgApiImpl extends PsHttpService implements PlgApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`,
        };
    }

    async getInvitationList(params: IGetInvitationListRequest): Promise<IInvitationListResponse> {
        return this.post<PatSnapCommonResponseData<IInvitationListResponse>>({
            url: 'plg/reward/invitation-records',
            data: params,
        }).then(res => res.data as IInvitationListResponse);
    }

    async redeemReward(params: IRedeemRequest): Promise<boolean> {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: 'plg/reward/redeem',
            data: params,
        }).then(res => res.data as boolean);
    }

    async getRewardStatus(): Promise<IRewardStatusResponse> {
        return this.get<PatSnapCommonResponseData<IRewardStatusResponse>>({
            url: 'plg/reward/status',
        }).then(res => res.data as IRewardStatusResponse);
    }
}
